import styled from 'styled-components';

export const Card = styled.div`
  button {
    width: 100%;
    text-align: left;
    text-decoration: none;

    span {
      font-size: 14px;
    }
  }
`;
